import script from "./SpinWinners.vue?vue&type=script&setup=true&lang=js"
export * from "./SpinWinners.vue?vue&type=script&setup=true&lang=js"

import "./SpinWinners.vue?vue&type=style&index=0&id=4d1994b3&scoped=true&lang=css"

import exportComponent from "/home/runner/work/admin_6_0/admin_6_0/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d1994b3"]])

export default __exports__